export const EventTypes = {
  EVENT_TYPE_WALLET_ACTIVITY: 'wallet_activity',
  EVENT_TYPE_ERC721_TRANSFER: 'erc721_transfer',
  EVENT_TYPE_ERC20_TRANSFER: 'erc20_transfer',
  EVENT_TYPE_SMART_CONTRACT_ACTIVITY: 'smart_contract_event_activity',
};

export const SUPPORTED_EVENT_TYPES = Object.values(EventTypes);

export const WEBHOOK_STATUS = {
  active: 'active',
  // active: 'webhook_active',
  deactivated: 'inactive',
  // deactivated: 'webhook_inactive',
};
